<template>
    <div class="app-container">
        <el-form
            ref="addAddressform"
            label-width="100px"
            :inline="true"
            :model="addAddressform"
            :rules="addAddressRules"
        >
            <el-form-item label="安装地区" prop="label">
                <el-cascader
                    ref="district"
                    v-model="addAddressform.label"
                    :options="options_"
                    placeholder="省市区"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input
                    v-model="addAddressform.address"
                    maxlength="50"
                    style="width: 240px"
                />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { regionData, CodeToText } from "element-china-area-data";

export default {
    props: {
        cid: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            options_: regionData,
            addAddressform: {
                label: "",
				address: "",
            },
            addAddressRules: {
                label: [
                    {
                        required: true,
                        message: "请选择安装地区",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入详细地址",
					},
                ],
            },
        };
    },
    methods: {
        save(val) {
            this.$refs.addAddressform.validate((valid) => {
                if (valid) {
                    let arr = [];
                    arr.push(CodeToText[this.addAddressform.label[0]]);
                    arr.push(CodeToText[this.addAddressform.label[1]]);
                    arr.push(CodeToText[this.addAddressform.label[2]]);
                    let obj = {
                        cid:this.cid,
                        district:arr.join(','),
                        address:this.addAddressform.address,
                        main:0,
                    }
                    this.$api.addCustomerWorkAddress(obj)
                        .then((res) => {
                            this.$emit("close",val);
                            this.$notify({
                                title: "新增安装地址",
                                message: "新增成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.addAddressform = {
                                        label: "",
				                        address: "",
                                    };
                                },
                            });
                        });
                } else {
                    this.$notify({
                        title: "信息填写不完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                    });
                }
            });
        },
    },
};
</script>